import React from "react";

export default function Cookie() {
  return (
    <div data-testid="cookie-page" className="container-xl py-14 md:py-20 max-w-3xl">
      <div className="text-xs uppercase tracking-[0.3em] text-[hsl(var(--primary))] font-semibold mb-2">Legal</div>
      <h1 className="editorial-heading text-4xl md:text-5xl mb-2">Cookie Policy</h1>
      <p className="text-sm text-muted-foreground">Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</p>

      <div className="mt-10 space-y-8 text-sm md:text-base leading-relaxed text-foreground/85">
        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">Che cosa sono i cookie?</h2>
          <p>I cookie sono piccoli file di testo che vengono salvati sul tuo dispositivo quando visiti un sito web. Aiutano il sito a riconoscerti, ricordare le tue preferenze e misurare le performance.</p>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">Cookie utilizzati da Amazonico 3000</h2>

          <div className="space-y-5 mt-5">
            <div className="bg-card border border-border rounded-sm p-5">
              <div className="flex items-center justify-between mb-2">
                <div className="font-bold">🔒 Cookie essenziali</div>
                <span className="chip bg-green-100 text-green-900 text-xs">Sempre attivi</span>
              </div>
              <p className="text-sm text-muted-foreground">Necessari al funzionamento del sito: autenticazione (JWT token), carrello, preferenze lingua. Non richiedono consenso.</p>
              <div className="mt-3 text-xs text-muted-foreground">
                <strong>Durata:</strong> sessione o 30 giorni · <strong>Dominio:</strong> amazonico3000.com
              </div>
            </div>

            <div className="bg-card border border-border rounded-sm p-5">
              <div className="flex items-center justify-between mb-2">
                <div className="font-bold">📊 Cookie di analytics</div>
                <span className="chip bg-[hsl(var(--muted))] text-xs">Opzionali</span>
              </div>
              <p className="text-sm text-muted-foreground">Ci permettono di capire come viene utilizzato il sito in forma anonima e aggregata (pagine più visitate, tempo medio, dispositivo).</p>
              <div className="mt-3 text-xs text-muted-foreground">
                <strong>Durata:</strong> 13 mesi · <strong>Tools:</strong> tracciamento interno (no Google Analytics)
              </div>
            </div>

            <div className="bg-card border border-border rounded-sm p-5">
              <div className="flex items-center justify-between mb-2">
                <div className="font-bold">🎯 Cookie di marketing</div>
                <span className="chip bg-[hsl(var(--muted))] text-xs">Opzionali</span>
              </div>
              <p className="text-sm text-muted-foreground">Usati per personalizzare offerte, raccomandazioni di vini e contenuti in base ai tuoi interessi.</p>
              <div className="mt-3 text-xs text-muted-foreground">
                <strong>Durata:</strong> 6 mesi · <strong>Gestione:</strong> interna
              </div>
            </div>
          </div>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">Come gestire i cookie</h2>
          <p>Al primo accesso mostriamo un banner per raccogliere il tuo consenso. Puoi modificare le tue preferenze in qualsiasi momento:</p>
          <ul className="list-disc pl-6 space-y-1.5 mt-3">
            <li>Cancellando il cookie <code className="bg-[hsl(var(--muted))] px-1.5 py-0.5 rounded text-xs">a3k_consent</code> dal tuo browser per far riapparire il banner</li>
            <li>Scrivendo a <a href="mailto:privacy@amazonico3000.com" className="text-[hsl(var(--primary))] underline">privacy@amazonico3000.com</a></li>
            <li>Configurando le impostazioni del tuo browser (Chrome, Safari, Firefox, Edge hanno opzioni dedicate)</li>
          </ul>
        </section>

        <section>
          <h2 className="editorial-heading text-xl md:text-2xl mb-3">Conformità normativa</h2>
          <p>Questa policy è conforme a:</p>
          <ul className="list-disc pl-6 space-y-1.5">
            <li>Regolamento UE 2016/679 (GDPR)</li>
            <li>Direttiva ePrivacy 2002/58/CE</li>
            <li>Linee guida Garante Privacy italiano (giugno 2021)</li>
            <li>Codice della Privacy italiano (D.lgs. 196/2003)</li>
          </ul>
        </section>

        <section className="bg-card border border-border rounded-sm p-5">
          <h3 className="font-bold mb-2">Contatti</h3>
          <p className="text-sm">Per qualsiasi domanda relativa ai cookie o al trattamento dei dati: <a href="mailto:privacy@amazonico3000.com" className="text-[hsl(var(--primary))] underline">privacy@amazonico3000.com</a></p>
        </section>
      </div>
    </div>
  );
}
